import { Dialog as DialogCore } from '@material-ui/core';
import { colors, paddings, fonts, margins } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${paddings.alternative}px;

  .loading {
    width: 15px!important;
    height: 15px!important;
    position: absolute;
    top: 30px;
    right: 20px;
  }

  h3 {
    font-size: ${fonts.default}px;
    color: ${colors.black};
    margin: ${margins.reset}px;
    font-weight: 300;
    margin-bottom: ${margins.default}px;
  }
`;

export const ListExtensions = lib.styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const ItemQueue = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  height: 48px;
  background-color: ${colors.white02};
  border: 1px dotted ${colors.lightGray06};
  border-radius: 10px;
  padding-left: ${paddings.alternative}px;
  padding-right: ${paddings.alternative}px;
  margin-bottom: 5px;
  font-size: 14px;

  .icon {
    max-width: 25px;
  }

  .description {
    display: flex;
    flex: 5;
    padding-left: 5px;
    color: #bababa;
  }

  .switch {
    display: flex; 
    flex: 1;
  }

  .type {
    display: flex; 
    flex: 3;
    font-size: 10px;
    font-weight: 600;
    margin-right: 15px;
    color: #ee4c40;
  }
`;

export const Dialog = lib.styled(DialogCore)`
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .MuiPaper-root {
    background-color: transparent;
  }

  .MuiPaper-elevation24 {
    box-shadow: none;
  }

  .MuiCircularProgress-colorPrimary {
    color: #29cf6a;
  }
`;
